module.exports = __webpack_public_path__ + "static/img/wx-6.25ff579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wx-6.png
// module id = 4QXN
// module chunks = 10